import type { LegendItem } from "@typings/components/map";
import Map from "@commons/Map";
import Popup from "./Popup";
import { usePage } from "@hooks/usePage";
import AdminAnalysisTable from "./AdminAnalysisTable";
import { CircularProgress } from "@mui/material";
import type { ReleasesFilters } from "@services/releases/list/type";
import type { ReleaseGeoJsonProperties } from "@services/releases/getGeoJson/type";
import { useGetReleasesGeoJson } from "@services/releases/getGeoJson";
import { useEffect } from "react";
import { AppError } from "@utils/errors/appError";
import { toast } from "react-toastify";
import { mapColorToReleases } from "@utils/translator/releases";
import { usePermissions } from "@hooks/usePermissions";

const LEGENDS = [
  { label: "Pendente", color: "bg-yellow-500" },
  { label: "Aguardando Análise do Admin", color: "bg-secondary" },
  { label: "Concluída", color: "bg-primary" },
  { label: "Cancelada", color: "bg-red-600" },
] as LegendItem[];

function MapView({ appliedFilters }: { appliedFilters: ReleasesFilters }) {
  const { openModal } = usePage();

  const { can } = usePermissions();

  const { data, isLoading, error } = useGetReleasesGeoJson(appliedFilters);

  const processedData = data ? mapColorToReleases(data) : null;

  const canCreateRelease = can("create", "releases");

  useEffect(() => {
    if (error) {
      const isAppError = error instanceof AppError;

      const title = isAppError
        ? error.message
        : "Erro ao carregar solturas! Tente novamente!";
      toast.error(title, { autoClose: 6000 });
    }
  }, [error]);

  return (
    <div className="w-full flex flex-col">
      <div className="h-[calc(100vh-12rem)] bg-white rounded-lg shadow-md p-4 min-h-96 flex flex-col">
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            <Map.Root>
              {canCreateRelease && (
                <Map.Button onClick={() => openModal("newRelease")}>
                  Nova Soltura
                </Map.Button>
              )}
              <Map.Draw<ReleaseGeoJsonProperties>
                geoJsonData={processedData}
                popupComponent={Popup}
                canCreate={canCreateRelease}
                modalToOpen="newRelease"
                coordinatesButtonLabel="Nova Soltura"
              />
              <Map.Footer legends={LEGENDS} />
            </Map.Root>
          </>
        )}
      </div>

      <AdminAnalysisTable />
    </div>
  );
}

export default MapView;
